<template>
  <div>
    <div style="width: 100%;height: 100vh;padding: 10px">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>注册用户</span>
          <!--          <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
        </div>
        <div style="width: 90%;margin: auto">
          <el-form :model="formData" :inline="false" :rules="rules" label-width="100px">
            <el-form-item label="头像">
              <el-avatar :size="60" :src="formData.avatar" @error="true">
                <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
              </el-avatar>
            </el-form-item>
            <el-form-item label="用户账号" prop="username">
              <el-input v-model="formData.username" placeholder="用户账号" clearable/>
              <!--              <span>{{ formData.username }}</span>-->
            </el-form-item>
            <el-form-item label="用户名称">
              <span>{{ formData.name }}</span>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="formData.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="formData.email" placeholder="邮箱" clearable/>
            </el-form-item>
            <el-form-item label="手机号码">
              <span>{{ formData.mobile }}</span>
            </el-form-item>
            <!--            <el-form-item label="职位">-->
            <!--              <el-input v-model="formData.title" placeholder="职位" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="工号">-->
            <!--              <el-input v-model="formData.job_number" placeholder="工号" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="备注">-->
            <!--              <el-input v-model="formData.remark" placeholder="备注" clearable/>-->
            <!--            </el-form-item>-->
            <el-form-item>
              <el-button type="warning" @click="getUserInfo" :disabled="loading" :loading="loading">重新获取用户信息</el-button>
              <el-button type="primary" @click="onSubmit">确认用户信息并注册</el-button>
              <el-button @click="goToLogin">返回登录页面</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {dingTalkRegister, getUserInfoByUnionId} from "../../api/common";

export default {
  name: "register",
  data() {
    return {
      unionid: '',
      formData: {
        openid: '',
        dt_userid: '',
        unionid: '',//mPE4uZvVxQySUFjy6RMqLwiEiE
        username: '',//账号
        name: '',
        sex: 0,
        avatar: '',
        mobile: '',
        job_number: '',
        title: '',
        email: '',
        remark: '',
      },
      info: {},
      loading: false,
      rules: {
        username: [
          {required: true, message: '请输入账号', trigger: 'blur'},
          {min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    async onSubmit() {
      await dingTalkRegister(this.formData).then(async (res) => {
        if (res.success) {
          this.$notify.success('注册成功')
          await this.$msgbox.alert('注册成功,前往登录页面扫码登录', '标题名称', {
            confirmButtonText: '确定',
            callback: () => {
              this.$router.push({name: 'login'})
              // this.$message({
              //   type: 'info',
              //   message: `action: ${ action }`
              // });
            }
          });
        } else {
          this.$notify.error(res.message)
          return false
        }
        return res.model;
      })


    },
    goToLogin() {
      this.$router.push({'name': 'login'})
    },
    async getUserInfo() {
      this.loading = true
      let {info} = await getUserInfoByUnionId({unionid: this.unionid}).then((res) => {

        return res.model;
      })
      this.info = info
      this.formData.dt_userid = info.userid
      this.formData.unionid = info.unionid
      this.formData.name = info.name
      this.formData.mobile = info.mobile
      this.formData.email = info.email
      this.formData.avatar = info.avatar
      this.formData.title = info.title
      this.formData.job_number = info.job_number
      this.formData.remark = info.remark
      this.loading = false
    }
  },
  created() {
    this.unionid = this.$route.params.unionid
    this.formData.openid = this.$route.query.openid;
    this.getUserInfo()
  }
}
</script>

<style scoped>

.box-card {
  width: 900px;
  min-width: 800px;
  margin: auto;
}
</style>
